/* eslint-disable camelcase */
import * as yup from 'yup';
import { Schema } from 'yup';

export interface SendingOrderEdit {
  id?: number | undefined;
  date_id: number;
  product_id: number;
  color: boolean;
  customer?: string | undefined;
  message?: string | undefined;
}

export const SendingOrderEditSchema: Schema<SendingOrderEdit> = yup.object().shape({
  id: yup.number().optional(),
  date_id: yup.number().required('Måste anges').typeError('Måste välja datum'),
  product_id: yup.number().required('Måste anges').typeError('Måste välja typ av utskick'),
  color: yup.boolean().required('Måste anges'),
  customer: yup.string().optional(),
  message: yup.string().optional(),
});
